// extracted by mini-css-extract-plugin
module.exports = {"label":"MenuItemToggle-module_label__1WG8pxGO3l1STVtH0gAhkR","container":"MenuItemToggle-module_container__DU-a5QZTqzkMrqMYbFVEE"};